import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketplace-hero-slide-text-block',
  templateUrl: './marketplace-hero-slide-text-block.component.html',
})
export class MarketplaceHeroSlideTextBlockComponent {
  @Input() text = '';
}
